export enum SocketName {
  default = 'default',
  inaction = 'inaction',
  success = 'success',
  fail = 'fail',
  input = 'input',
  mainInput = 'main-input',
  mainOutput = 'main-output',
}

export enum SocketColor {
  default = '#3399ff',
  start = '#3399ff',
  inaction = '#d760fd',
  success = '#43a515',
  fail = '#f5222d',
  input = '#FFA500',
  mainOutput = '#3399ff',
  mainInput = '#FFA500',
}

export enum ContextMenuType {
  Nodes,
  Actions,
}

export enum NodeTypes {
  Start = 'Start',
  SendMessage = 'SendMessage',
  Randomizer = 'Randomizer',
  Delay = 'Delay',
  Conditions = 'Condition',
  SendInvoice = 'SendInvoice',
  Json = 'JsonRequest',
  RunFlow = 'RunFlow',
  EditLastMessage = 'EditLastMessage',
  CheckSubscription = 'CheckSubscription',
  PrivateMessage = 'SendPrivateMessage',
  CreateLimitedSubscription = 'CreateLimitedSubscription',
  Error = 'Error',
  Action = 'Action',
  CheckLimitedSubscription = 'CheckLimitedSubscription',
  InfoLimitedSubscription = 'InfoLimitedSubscription',
  ForwardMessage = 'ForwardMessage',
}

export enum NewPropertyNumbersConditionAction {
  More = 'More',
  Less = 'Less',
  MoreOrEquals = 'MoreOrEquals',
  LessOrEquals = 'LessOrEquals',
  Equals = 'Equals',
  Contains = 'Contains',
  BetweenProperty = 'BetweenProperty',
}

export enum PropertyFieldType {
  Date = 'Date',
  Time = 'Time',
  DateTime = 'DateTime',
  Number = 'Number',
  Double = 'Double',
  String = 'String',
  Flag = 'Flag',
  // Location = 'Location',
  Phone = 'Phone',
  Email = 'Email',
  Files = 'Files',
  URL = 'URL',
}

export enum MessageNodeActionTypes {
  Message = 'Message',
  Typing = 'Typing',
  UserInput = 'Property'
}

export enum ProductType {
  Goods = 'Goods',
  Service = 'Service',
  Licence = 'Licence',
}

export enum FLowProject {
  PressCode = 'PressCode',
  BotBuilder = 'BotBuilder',
}
